import React from "react";
import { Whisper, Popover } from "rsuite";
import { useLocation, useNavigate } from "react-router-dom";
import { MdOutlineVisibility, MdOutlineEdit } from "react-icons/md";
import { FaWpforms } from "react-icons/fa6";
import { useLazyGetLabReportsOverviewQuery } from "../../State/Api/AddLabReportsApiSlice";

const ActionCellClinicReports = (props) => {
  const navigate = useNavigate(); 
 const location = useLocation();
  const [fetchReportOverview] = useLazyGetLabReportsOverviewQuery();

  const handleViewReports = async () => {
    const appointmentID = props?.data?.appointmentID;
    const patientUserUniqueID = props?.data?.patientUserUniqueID;

    if (appointmentID && patientUserUniqueID) {
      try {
        const result = await fetchReportOverview({
          appointmentID,
          patientUserUniqueID,
        }).unwrap();
        navigate("/ViewReports", {
          state: {
            reportData: result,
          },
        });
      } catch (error) {
        console.error("Failed to fetch report overview:", error);
      }
    }
  };

  const renderPopover = (
    <Popover arrow={false} full className="p-2 rounded-md w-42">
      <div className="px-3 pt-2 pb-1 text-sm font-bold text-gray-800">
        Actions
      </div>

      <div
        onClick={() => navigate(`/ViewReports/${props?.data?.patientUserUniqueID}/${props?.data?.appointmentID}`)}
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 rounded-md"
      >
        <MdOutlineVisibility className="text-lg text-gray-500" />
        <span>View</span>
      </div>

      <div
      ///  onClick={() => navigate(`/ClinicPatientView/${props?.data?.patientUserUniqueID}`)}
      onClick={() => navigate(`/ClinicPatientView/${props?.data?.patientUserUniqueID}?from=${encodeURIComponent(
              location.pathname + location.search
            )}`)}
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 rounded-md"
      >
        <FaWpforms className="text-lg text-gray-500" />
        <span>Patient Details</span>
      </div>
    </Popover>
  );

  return (
    <Whisper placement="autoVerticalEnd" trigger="click" speaker={renderPopover}>
      <button
        className="inline-flex items-center justify-center gap-2 w-10 h-10 rounded-md hover:bg-gray-100"
        title="More actions"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="lucide lucide-ellipsis h-4 w-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
        >
          <circle cx="12" cy="12" r="1"></circle>
          <circle cx="19" cy="12" r="1"></circle>
          <circle cx="5" cy="12" r="1"></circle>
        </svg>
      </button>
    </Whisper>
  );
};

export default ActionCellClinicReports;
